import { FeatureName } from "@/common/constants/featureName";
import { featureManager } from "@/config/features";
import { ProfileDto } from "@/core/api/generated/v1";

import { ObjectHelper } from "../object";

export class OneflowHelper {
  public static isFeatureEnabledForTenantUser(profile: Nil<ProfileDto>): boolean {
    return (
      // app level feature flag
      featureManager.isEnabled(FeatureName.OneflowIntegration) &&
      // tenant user level feature flag
      ObjectHelper.getRecordValueByStringKey(
        profile?.features ?? {},
        FeatureName.OneflowIntegration,
        { isIgnoreCase: true },
      ) === true
    );
  }
}
